module.exports = __webpack_public_path__ + "static/media/outfit2.8b6a13bd.jpg";